module.exports = __webpack_public_path__ + "media/images/bet__correctMarker@2x-e33fd155b26bac7475aac1d3a94b9a3e.png";